var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverlayLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 652,
    height: 286,
    viewBox: "0 0 652 286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.539,
    y1: 0.112,
    x2: -0.388,
    y2: 1.778,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e59d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2d69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14555",
    "data-name": "Group 14555",
    transform: "translate(-98 -2628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "brooke-cagle-g1Kr4Ozfoac-unsplash",
    d: "M0,0H652a0,0,0,0,1,0,0V71A215,215,0,0,1,437,286H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(98 2628)",
    fill: "#7e59d1",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "brooke-cagle-g1Kr4Ozfoac-unsplash-2",
    "data-name": "brooke-cagle-g1Kr4Ozfoac-unsplash",
    d: "M0,0H634a0,0,0,0,1,0,0V71A215,215,0,0,1,419,286H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(98 2628)",
    fill: "#7e59d1",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "brooke-cagle-g1Kr4Ozfoac-unsplash-3",
    "data-name": "brooke-cagle-g1Kr4Ozfoac-unsplash",
    d: "M0,0H616a0,0,0,0,1,0,0V71A215,215,0,0,1,401,286H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(98 2628)",
    opacity: 0.93,
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayLeft);
export default __webpack_public_path__ + "static/media/overlay-left.7400457be2e365eab9bccc812cb3bbab.svg";
export { ForwardRef as ReactComponent };